module.exports = __webpack_public_path__ + "img/galtseva.5f0b45b0.jpg";